export default __webpack_public_path__ + "static/media/menIcon.3341d5ae.png";